module.exports = __webpack_public_path__ + "img/6_cover2.18acd720.png";